<template>
<div id="app">
    <router-view/>
</div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="scss">
@import "~@/styles/theme.scss";

html,
body,
#app {   
    height: 100%;
    margin: 0px;
    padding: 0px;
}

a,
a:focus,
a:hover {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
}

ul,li{
    list-style:none
}
.el-card__body{
    padding: 20px 16px ;
}
.amap-logo{
  display: none;
  visibility: hidden;
}
.amap-copyright{
  visibility: hidden!important;
}
.wsNotification {
    i {
        color: #2cac85;
    }
    h2 { 
        color: #333
    }
}
img {
    object-fit: contain;
}
</style>